import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const ProgressBarBackground = styled.div(props => ({
    height: "12px",
    borderRadius: "16px",
    backgroundColor: theme(props).keyPalette.panel2BackgroundColor,
}));

export const ProgressBarActive = styled.div(props => ({
    height: "12px",
    borderRadius: "16px",
    backgroundColor: theme(props).typography.primary.color,
    transition: "width 0.2s ease-in",
}));
